import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTrackEventMutation } from 'src/common/slices/analytics';
import ReasonEffectivenessImage1 from 'src/images/svgs/business/reason-effectiveness-1.svg';
import ReasonEffectivenessImage2 from 'src/images/svgs/business/reason-effectiveness-2.svg';
import ReasonEffectivenessImage3 from 'src/images/svgs/business/reason-effectiveness-3.svg';
import ReasonSocImage1 from 'src/images/svgs/business/reason-soc-1.svg';
import ReasonSocImage2 from 'src/images/svgs/business/reason-soc-2.svg';
import ReasonSocImage3 from 'src/images/svgs/business/reason-soc-3.svg';
// import KpmgLogo from 'src/images/pngs/soc-sim/kpmg.png';
import ReasonThImage1 from 'src/images/svgs/business/reason-th-1.svg';
import ReasonThImage2 from 'src/images/svgs/business/reason-th-2.svg';
import ReasonThImage3 from 'src/images/svgs/business/reason-th-3.svg';
import { BookNowModal } from '../book-now-modal/book-now-modal';
import { StyledDescription, StyledHeading } from '../commons/commons.styles';
import { StyledBenefitCard, StyledBenefitCardImage, StyledBenefitContent, StyledBenefitFeatureItem, StyledBenefitFeatures, StyledBenefitHeader,
// StyledBenefitImagePlaceholder,
// StyledBenefitStatBox,
// StyledBenefitStatDescription,
// StyledBenefitStatValue,
StyledBenefitsContainer, StyledBenefitTitle, StyledContainer, StyledHeaderSection, StyledTag, StyledTagContent, StyledTagGradient, StyledTagText } from './benefits-section.styles';
export const BenefitsSection = () => {
  const [activeBenefit1, setActiveBenefit1] = useState(0);
  const [activeBenefit2, setActiveBenefit2] = useState(0);
  const [activeBenefit3, setActiveBenefit3] = useState(0);
  const [isBookNowOpen, setIsBookNowOpen] = useState(false);
  const [trackEvent] = useTrackEventMutation();
  const handleBookDemo = () => {
    trackEvent({
      event: 'click-book-demo'
    });
    setIsBookNowOpen(true);
  };
  return <>
      <StyledContainer data-sentry-element="StyledContainer" data-sentry-source-file="benefits-section.tsx">
        <StyledHeaderSection data-sentry-element="StyledHeaderSection" data-sentry-source-file="benefits-section.tsx">
          <StyledTag onClick={handleBookDemo} data-sentry-element="StyledTag" data-sentry-source-file="benefits-section.tsx">
            <StyledTagGradient data-sentry-element="StyledTagGradient" data-sentry-source-file="benefits-section.tsx">
              <StyledTagText data-sentry-element="StyledTagText" data-sentry-source-file="benefits-section.tsx">Get started</StyledTagText>
            </StyledTagGradient>
            <StyledTagContent data-sentry-element="StyledTagContent" data-sentry-source-file="benefits-section.tsx">
              <span>Gain full access today</span>
              <FontAwesomeIcon icon={faChevronRight} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="benefits-section.tsx" />
            </StyledTagContent>
          </StyledTag>

          <StyledHeading data-sentry-element="StyledHeading" data-sentry-source-file="benefits-section.tsx">Go Business for all the right reasons</StyledHeading>

          <StyledDescription data-sentry-element="StyledDescription" data-sentry-source-file="benefits-section.tsx">
            See how TryHackMe for Teams helps sharpen investigative skills, speed up threat response
          </StyledDescription>
        </StyledHeaderSection>

        {/* Benefit 1: Reduced exposure */}
        <StyledBenefitsContainer data-sentry-element="StyledBenefitsContainer" data-sentry-source-file="benefits-section.tsx">
          <StyledBenefitContent data-sentry-element="StyledBenefitContent" data-sentry-source-file="benefits-section.tsx">
            <StyledBenefitHeader data-sentry-element="StyledBenefitHeader" data-sentry-source-file="benefits-section.tsx">
              <StyledBenefitTitle data-sentry-element="StyledBenefitTitle" data-sentry-source-file="benefits-section.tsx">Give your team the confidence to handle any threat</StyledBenefitTitle>
              <StyledDescription data-sentry-element="StyledDescription" data-sentry-source-file="benefits-section.tsx">
                Develop practical skills that turn confidence into faster, more accurate detection and responses.
              </StyledDescription>
            </StyledBenefitHeader>

            <StyledBenefitFeatures data-sentry-element="StyledBenefitFeatures" data-sentry-source-file="benefits-section.tsx">
              <StyledBenefitFeatureItem isActive={activeBenefit1 === 0} onMouseEnter={() => setActiveBenefit1(0)} data-sentry-element="StyledBenefitFeatureItem" data-sentry-source-file="benefits-section.tsx">
                <span>Hands-on interactive training</span>
                <p>
                  Build muscle memory through practical, interactive scenarios or exercises that strengthen team
                  readiness.
                </p>
              </StyledBenefitFeatureItem>
              <StyledBenefitFeatureItem isActive={activeBenefit1 === 1} onMouseEnter={() => setActiveBenefit1(1)} data-sentry-element="StyledBenefitFeatureItem" data-sentry-source-file="benefits-section.tsx">
                <span>Content for all roles and experience levels</span>
                <p>
                  Upskill your entire team through tailored, role-based learning paths, or design your own custom
                  content to match organisational needs.
                </p>
              </StyledBenefitFeatureItem>
              <StyledBenefitFeatureItem isActive={activeBenefit1 === 2} onMouseEnter={() => setActiveBenefit1(2)} data-sentry-element="StyledBenefitFeatureItem" data-sentry-source-file="benefits-section.tsx">
                <span>Wide coverage of real-world attack techniques and enterprise technologies</span>
                <p>Covering the latest attack techniques, frameworks, and technologies used in real breaches.</p>
              </StyledBenefitFeatureItem>
            </StyledBenefitFeatures>

            {/* <StyledBenefitStatBox>
              <StyledBenefitStatValue>35%</StyledBenefitStatValue>
              <StyledBenefitStatDescription>
                Reduction in high-severity incident impact after six months.
              </StyledBenefitStatDescription>
              <StyledBenefitImagePlaceholder src={KpmgLogo} alt="KPMG" />
             </StyledBenefitStatBox> */}
          </StyledBenefitContent>

          <StyledBenefitCard data-sentry-element="StyledBenefitCard" data-sentry-source-file="benefits-section.tsx">
            {activeBenefit1 === 0 && <StyledBenefitCardImage src={ReasonThImage1} alt="TryHackMe threat handling" />}
            {activeBenefit1 === 1 && <StyledBenefitCardImage src={ReasonThImage2} alt="TryHackMe threat handling" />}
            {activeBenefit1 === 2 && <StyledBenefitCardImage src={ReasonThImage3} alt="TryHackMe threat handling" />}
          </StyledBenefitCard>
        </StyledBenefitsContainer>

        {/* Benefit 2: Continuous readiness */}
        <StyledBenefitsContainer $reversed data-sentry-element="StyledBenefitsContainer" data-sentry-source-file="benefits-section.tsx">
          <StyledBenefitContent data-sentry-element="StyledBenefitContent" data-sentry-source-file="benefits-section.tsx">
            <StyledBenefitHeader data-sentry-element="StyledBenefitHeader" data-sentry-source-file="benefits-section.tsx">
              <StyledBenefitTitle data-sentry-element="StyledBenefitTitle" data-sentry-source-file="benefits-section.tsx">Prepare your SOC for real attacks with simulated environments</StyledBenefitTitle>
              <StyledDescription data-sentry-element="StyledDescription" data-sentry-source-file="benefits-section.tsx">
                Scale real-world readiness with training that keeps skills sharp and avoids learning-fatigue.
              </StyledDescription>
            </StyledBenefitHeader>

            <StyledBenefitFeatures data-sentry-element="StyledBenefitFeatures" data-sentry-source-file="benefits-section.tsx">
              <StyledBenefitFeatureItem isActive={activeBenefit2 === 0} onMouseEnter={() => setActiveBenefit2(0)} data-sentry-element="StyledBenefitFeatureItem" data-sentry-source-file="benefits-section.tsx">
                <span>Triage SOC Simulator</span>
                <p>Provide your analysts with ongoing, lifelike incident investigations of various difficulties.</p>
              </StyledBenefitFeatureItem>
              <StyledBenefitFeatureItem isActive={activeBenefit2 === 1} onMouseEnter={() => setActiveBenefit2(1)} data-sentry-element="StyledBenefitFeatureItem" data-sentry-source-file="benefits-section.tsx">
                <span>Threat Hunting Simulator</span>
                <p>
                  Recreate the full attack chain so your team can think like an adversary and identify detection gaps.
                </p>
              </StyledBenefitFeatureItem>
              <StyledBenefitFeatureItem isActive={activeBenefit2 === 2} onMouseEnter={() => setActiveBenefit2(2)} data-sentry-element="StyledBenefitFeatureItem" data-sentry-source-file="benefits-section.tsx">
                <span>Tabletop Exercises</span>
                <p>
                  AI-powered tabletop exercises reveal gaps, strengthen coordination, and turn practice into real-world
                  resilience.
                </p>
              </StyledBenefitFeatureItem>
            </StyledBenefitFeatures>

            {/* <StyledBenefitStatBox>
              <StyledBenefitStatValue>45%</StyledBenefitStatValue>
              <StyledBenefitStatDescription>
                Reduced breach costs with continuous team training.
              </StyledBenefitStatDescription>
              <StyledBenefitImagePlaceholder src={KpmgLogo} alt="KPMG" />
             </StyledBenefitStatBox> */}
          </StyledBenefitContent>

          <StyledBenefitCard data-sentry-element="StyledBenefitCard" data-sentry-source-file="benefits-section.tsx">
            {activeBenefit2 === 0 && <StyledBenefitCardImage src={ReasonSocImage1} alt="TryHackMe SOC Simulator" />}
            {activeBenefit2 === 1 && <StyledBenefitCardImage src={ReasonSocImage2} alt="TryHackMe SOC Simulator" />}
            {activeBenefit2 === 2 && <StyledBenefitCardImage src={ReasonSocImage3} alt="TryHackMe SOC Simulator" />}
          </StyledBenefitCard>
        </StyledBenefitsContainer>

        {/* Benefit 3: Proven growth */}
        <StyledBenefitsContainer data-sentry-element="StyledBenefitsContainer" data-sentry-source-file="benefits-section.tsx">
          <StyledBenefitContent data-sentry-element="StyledBenefitContent" data-sentry-source-file="benefits-section.tsx">
            <StyledBenefitHeader data-sentry-element="StyledBenefitHeader" data-sentry-source-file="benefits-section.tsx">
              <StyledBenefitTitle data-sentry-element="StyledBenefitTitle" data-sentry-source-file="benefits-section.tsx">Measure how skill development strengthens SOC effectiveness</StyledBenefitTitle>
              <StyledDescription data-sentry-element="StyledDescription" data-sentry-source-file="benefits-section.tsx">
                Quantify skill growth, identify areas for improvement, and show measurable ROI in SOC performance.{' '}
              </StyledDescription>
            </StyledBenefitHeader>

            <StyledBenefitFeatures data-sentry-element="StyledBenefitFeatures" data-sentry-source-file="benefits-section.tsx">
              <StyledBenefitFeatureItem isActive={activeBenefit3 === 0} onMouseEnter={() => setActiveBenefit3(0)} data-sentry-element="StyledBenefitFeatureItem" data-sentry-source-file="benefits-section.tsx">
                <span>Skills aligned to industry frameworks</span>
                <p>
                  Assess and track capabilities across frameworks like MITRE ATT&CK and NIST to ensure your team meets
                  industry benchmarks.
                </p>
              </StyledBenefitFeatureItem>
              <StyledBenefitFeatureItem isActive={activeBenefit3 === 1} onMouseEnter={() => setActiveBenefit3(1)} data-sentry-element="StyledBenefitFeatureItem" data-sentry-source-file="benefits-section.tsx">
                <span>Uncover strengths and gaps</span>
                <p>
                  Identify where your team excels and where improvement is needed with detailed skill and performance
                  insights.
                </p>
              </StyledBenefitFeatureItem>
              <StyledBenefitFeatureItem isActive={activeBenefit3 === 2} onMouseEnter={() => setActiveBenefit3(2)} data-sentry-element="StyledBenefitFeatureItem" data-sentry-source-file="benefits-section.tsx">
                <span>Measure improvements</span>
                <p>Track progress over time to quantify growth, prove ROI, and guide future upskilling priorities.</p>
              </StyledBenefitFeatureItem>
            </StyledBenefitFeatures>

            {/* <StyledBenefitStatBox>
              <StyledBenefitStatValue>40%</StyledBenefitStatValue>
              <StyledBenefitStatDescription>
                increase in skills benchmark scores across MITRE ATT&CK tactics.
              </StyledBenefitStatDescription>
              <StyledBenefitImagePlaceholder src={KpmgLogo} alt="KPMG" />
             </StyledBenefitStatBox> */}
          </StyledBenefitContent>

          <StyledBenefitCard data-sentry-element="StyledBenefitCard" data-sentry-source-file="benefits-section.tsx">
            {activeBenefit3 === 0 && <StyledBenefitCardImage src={ReasonEffectivenessImage1} alt="TryHackMe SOC Effectiveness" />}
            {activeBenefit3 === 1 && <StyledBenefitCardImage src={ReasonEffectivenessImage2} alt="TryHackMe SOC Effectiveness" />}
            {activeBenefit3 === 2 && <StyledBenefitCardImage src={ReasonEffectivenessImage3} alt="TryHackMe SOC Effectiveness" />}
          </StyledBenefitCard>
        </StyledBenefitsContainer>
      </StyledContainer>

      <BookNowModal open={isBookNowOpen} onOpenChange={setIsBookNowOpen} title="Try for FREE" description="Enter your details to book a demo. We'll be in touch to schedule a time." data-sentry-element="BookNowModal" data-sentry-source-file="benefits-section.tsx" />
    </>;
};